import { axios } from "utils";

import { ADMIN_MANURE_ADDITIVES_URL as endpoint } from "consts";

import { ManureAdditive } from "models";

export const getManureAdditivesAdmin = async ({ enabled }: { enabled?: boolean } = {}): Promise<ManureAdditive[]> =>
  axios.get(endpoint, { params: { enabled } });
